import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

interface WizardProtectedRouteProps {
  children: React.ReactNode;
  currentStep: number;
  allowUnauthenticatedSteps?: number[];
}

export function WizardProtectedRoute({
  children,
  currentStep,
  allowUnauthenticatedSteps = [0, 1], // Allow steps 0 and 1 (identification and size evaluation) without auth
}: WizardProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  // Allow access to specified steps without authentication
  if (allowUnauthenticatedSteps.includes(currentStep)) {
    return <>{children}</>;
  }

  // For steps beyond the allowed unauthenticated steps, require authentication
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
